<template>
    <div class="bg-dark-blue dark-bar pb-2 pb-md-0">
        <div class="container">
            <div class="padding-20 d-flex justify-content-between align-items-center">
                <div class="icon e-rovinieta-icon"></div>
                <!-- <a href="https://e-rovinieta.ro/ro/?from=beta" class="d-none d-md-block btn btn-header">Versiune veche E-rovinieta</a> -->
                <div class="d-flex about-vignette align-items-center">
                    <div class="icon danger-sign-icon"></div>
                    <span v-if="isDesktop()" @click="openModal('infoModal')">
                        {{ $t('about') + ' ' + capitalize($t('site_erv')) }}
                    </span>
                    <span v-else class="fs-12" @click="openModal('infoModal')">{{ $t('info') }}</span>
                </div>
            </div>
        </div>
        <!-- <a href="https://e-rovinieta.ro/ro/?from=beta" class="d-block d-md-none btn btn-header">Versiune veche E-rovinieta</a> -->
        <div class="modal" id="infoModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title heading-small">
                            {{ $t('about') + ' ' + capitalize($t('site_erv')) }}
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <div class="icon icon-x"></div>
                        </button>
                    </div>
                    <div class="modal-body px-0 pt-0">
                        <div class="default-content">
                            <AboutErovContent/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AboutErovContent from './AboutErovContent.vue'
import TCPCModal from '../components/snippets/TCPCModal.vue'
import Heading from './snippets/Heading.vue'

export default {
    name: 'RovinietaNavigation',
    mixins: [
        TCPCModal
    ],
    props: {
    },
    components: {
        AboutErovContent,
        Heading
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .modal-body {
        .default-content {
           padding-top: 16px;;
        }
        height: 675px;
    }

    .fs-12 {
        @media only screen and (max-width: 768px) {
            font-size: 12px;
        }
    }
</style>
